module.exports = __webpack_public_path__ + "static/media/ic_accept.372b0943.svg";